import type { OperationalTimelineEntry } from '../executionTimelineFacade';
import type { CompactTimelineEntryProjection, CompactTimelineProjection } from './types';

const PRIMARY_LABELS = new Set([
  'Маршрут создан',
  'Выезд по маршруту',
  'Начата погрузка',
  'Погрузка завершена',
  'Начата выгрузка',
  'Выгрузка завершена',
  'Маршрут завершён'
]);

function isPrimaryEntry(entry: OperationalTimelineEntry): boolean {
  if (PRIMARY_LABELS.has(entry.label)) return true;
  if (entry.kind === 'incident') return true;
  if (entry.label.includes('простой') || entry.label.includes('Простой')) return true;
  if (entry.label.startsWith('Инцидент') || entry.label.startsWith('Зафиксирован')) return true;
  return false;
}

function mapKind(entry: OperationalTimelineEntry): CompactTimelineEntryProjection['kind'] {
  if (entry.kind === 'incident') {
    if (entry.label.includes('простой') || entry.label.includes('Простой')) return 'downtime';
    return 'incident';
  }
  if (entry.kind === 'system') return 'milestone';
  return entry.kind;
}

export function buildCompactTimelineProjection(
  rawEntries: OperationalTimelineEntry[]
): CompactTimelineProjection {
  const entries: CompactTimelineEntryProjection[] = rawEntries
    .filter(isPrimaryEntry)
    .map((entry) => {
      const contextLines = entry.contextLines ?? [];
      const detailLines: string[] = [];
      if (entry.address && !contextLines.includes(entry.address)) {
        detailLines.push(entry.address);
      }
      if (entry.detail && !contextLines.includes(entry.detail)) {
        detailLines.push(entry.detail);
      }

      return {
        key: entry.key,
        label: entry.label,
        at: entry.at,
        kind: mapKind(entry),
        completed: entry.completed,
        inProgress: entry.inProgress,
        summary: entry.detail ?? contextLines[0] ?? null,
        contextLines: contextLines.slice(0, 3),
        detailLines
      };
    });

  return { entries };
}
